import { olarkId } from '@fv/client-core'

import { Icon } from '../Icon.jsx'
import { useOlarkHooks } from './hooks.js'
import { expandOlarkBox } from './loadOlark.js'
import { useLoadOlark } from './useLoadOlark.js'
import type { OlarkVisitorConversationSync } from './useOlarkCommands.js'

export type { OlarkInternal } from './loadOlark.js'

type Props = OlarkVisitorConversationSync

export const OlarkChat = (props: Props) => {
  const { isLoading, loadOlark } = useLoadOlark({ mode: 'floating' })
  useOlarkHooks(props)

  const openChatBox = () => {
    if (!olarkId || isLoading) return

    loadOlark().then(() => {
      expandOlarkBox()
    })
  }

  return (
    <div
      id="olark_tab"
      className="fixed bottom-40 right-0 z-[5000] origin-bottom-right -rotate-90 print:hidden"
    >
      <button
        onClick={openChatBox}
        className="bg-[#76C7E7] px-4 py-2 text-[#333333]"
      >
        <Icon
          icon={isLoading ? 'spinner' : 'message-dots'}
          className="pointer-events-none pr-2 text-[#333333]"
        />
        Chat
      </button>
    </div>
  )
}
